import React from 'react';
import WidgetContextMenu from './widget-context-menu';

export default function OnlineTicketingContextMenu({ organization, online_ticketing }) {
    return (
        <WidgetContextMenu
            context={online_ticketing}
            usages={['sale', 'resale', 'multi_events']}
            organization={organization}
            footerCtaLabel="ticket.online_ticketing.menu.footer_cta"
            goBackLabel="ticket.online_ticketing.menu.go_back"
        />
    );
}
